<template>
  <base-dialog-form
    ref="userProfileDialog"
    class="pure"
    :title="$t('profile')"
    color="secondary"
    :type="type"
    icon="mdi-account"
  >
    <v-container
      id="profile-page"
      fluid
      tag="section"
    >
      <v-row>
        <v-col
          v-if="!$vuetify.breakpoint.smAndDown"
          cols="12"
          md="4"
        >
          <user-card
            :masterId="masterId"
            button-color="info"
          ></user-card>
        </v-col>
        <v-col
          cols="12"
          md="8"
        >
          <v-container
            id="profileData"
            fluid
            tag="section"
          >
            <base-material-card
              color="secondary"
              icon="mdi-account"
              class="profile-section "
              style="margin-top: 40px"
            >
              <v-layout>
                <v-tabs
                  v-if="!$vuetify.breakpoint.smAndDown"
                  v-model="tabs"
                  background-color="transparent"
                  color="secondary"
                  slider-color="secondary"
                >
                  <v-tab
                    id="tab-home"
                    class="mr-3"
                  >
                    <v-icon class="mr-2">mdi-timeline-clock-outline</v-icon>
                    {{ $t("timeline") }}
                  </v-tab>
                  <v-tab
                    id="tab-order"
                    class="mr-3"
                  >
                    <v-icon class="mr-2">mdi-cart-outline</v-icon>
                    {{ $t("orders") }}
                  </v-tab>
                  <v-tab
                    id="tab-certificate"
                    class="mr-3"
                  >
                    <v-icon class="mr-2">mdi-certificate-outline</v-icon>
                    {{ $t("certificates") }}
                  </v-tab>
                  <v-tab
                    id="tab-tessere"
                    class="mr-3"
                  >
                    <v-icon class="mr-2">mdi-card-account-details-outline</v-icon>
                    {{ $t("affiliation_cards") }}
                  </v-tab>
                  <v-tab
                    id="tab-profile"
                    class="mr-3"
                  >
                    <v-icon class="mr-2">mdi-account-edit</v-icon>
                    {{ $t("personal_data") }}
                  </v-tab>
                  <v-tab
                    id="tab-signature"
                    class="mr-3"
                  >
                    <v-icon class="mr-2">mdi-draw</v-icon>
                    {{ $t("signature") }}
                  </v-tab>
                  <v-tab
                    v-if="notifyData"
                    id="tab-notify"
                    class="mr-3"
                  >
                    <v-icon class="mr-2">mdi-bell</v-icon>
                    {{ $t("notify_rules") }}
                  </v-tab>
                </v-tabs>
                <div v-else class="mobileTabsMenu">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="secondary" block v-bind="attrs" v-on="on">
                        <v-icon left>{{ mobileTabs[tabs] ? mobileTabs[tabs].icon : 'mdi-account-edit' }}</v-icon>
                        {{ mobileTabs[tabs] ? mobileTabs[tabs].label : $t('profile') }}
                        <v-icon right>mdi-menu-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item v-for="(item, index) in mobileTabs" :key="index" @click="tabs = index">
                        <v-icon class="mr-2">{{ item.icon }}</v-icon>
                        <v-list-item-title>{{ item.label }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </v-layout>
              <v-tabs-items
                v-model="tabs"
                class="transparent tabs-container"
              >
                <v-tab-item v-if="$vuetify.breakpoint.smAndDown">
                  <!-- padding-top compensa il top negativo dell'avatar, tagliato dall'overflow:hidden di v-window -->
                  <div style="padding-top: 5px">
                    <user-card :masterId="masterId" button-color="info"></user-card>
                  </div>
                </v-tab-item>
                <v-tab-item>
                  <user-time-line :masterId="masterId"></user-time-line>
                </v-tab-item>
                <v-tab-item>
                  <list-ordini
                    :card="false"
                    mode="USER"
                    :masterId="masterId"
                    header-color="azure"
                  ></list-ordini>
                </v-tab-item>
                <v-tab-item>
                  <list-certificati
                    :card="false"
                    :masterId="masterId"
                    header-color="azure"
                  ></list-certificati>
                </v-tab-item>
                <v-tab-item>
                  <list-tessere-table
                    :masterId="masterId"
                    header-color="azure"
                  ></list-tessere-table>
                </v-tab-item>
                <v-tab-item>
                  <user-edit-profile
                    @isUpdated="emitUpdated"
                    type="plain"
                    paramsMode="EDIT"
                    :paramsMasterId="masterId"
                    paramsType="plain"
                    header-color="azure"
                  ></user-edit-profile>
                </v-tab-item>
                <v-tab-item>
                  <user-edit-signature
                    :masterId="masterId"
                    header-color="azure"
                  ></user-edit-signature>
                </v-tab-item>
                <v-tab-item v-if="notifyData">
                  <user-edit-auto-notify
                    :masterId="masterId"
                    header-color="azure"
                  ></user-edit-auto-notify>
                </v-tab-item>
              </v-tabs-items>
            </base-material-card>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </base-dialog-form>
</template>

<script>
import userCard from "@/widget/userCard.vue";
import userEditProfile from "@/widget/userEditProfile.vue";
import userEditSignature from "@/widget/userEditSignature.vue";
import userEditAutoNotify from "@/widget/userEditAutoNotify.vue";
import userTimeLine from "@/widget/userTimeLine.vue";
import listCertificati from "@/widget/listCertificati.vue";
import listTessereTable from "@/widget/listTessereTable.vue";
import listOrdini from "@/widget/listOrdini.vue";
export default {
  name: "profile-page",
  components: {
    userCard,
    userEditProfile,
    userEditSignature,
    userEditAutoNotify,
    userTimeLine,
    listCertificati,
    listTessereTable,
    listOrdini,
  },
  props: {
    paramsType: {
      type: String,
      default: null,
    },
    paramsMasterId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      type: null,
      masterId: null,
      startTab: null,
      tabs: 0,
      notifyData: false,
    };
  },
  computed: {
    mobileTabs() {
      return [
        { show: true, icon: "mdi-account", label: this.$t("user_card") },
        { show: true, icon: "mdi-timeline-clock-outline", label: this.$t("timeline") },
        { show: true, icon: "mdi-cart-outline", label: this.$t("orders") },
        { show: true, icon: "mdi-certificate-outline", label: this.$t("certificates") },
        { show: true, icon: "mdi-card-account-details-outline", label: this.$t("affiliation_cards") },
        { show: true, icon: "mdi-account-edit", label: this.$t("personal_data") },
        { show: true, icon: "mdi-draw", label: this.$t("signature") },
        { show: this.notifyData, icon: "mdi-bell", label: this.$t("notify_rules") },
      ].filter((t) => t.show);
    },
  },
  methods: {
    emitUpdated: function (data) {
      this.$emit("isUpdated", "true");
    },
    onTabChange(value) {
      // persiste la tab solo quando la pagina e' la route /portal/profile, non nei dialoghi
      if (this.type !== "plain") return;
      this.$router
        .replace({ query: { ...this.$route.query, tab: value } })
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") throw err;
        });
    },
    open(masterId, startTab) {
      this.type = "dialog";
      this.masterId = masterId;
      this.startTab = startTab;
      this.initProfileData();
      this.$refs.userProfileDialog.open();
    },
    initProfileData() {
      let _ = this;
      _.tabs = _.startTab || 0;
      _.notifyData = false;
      if (
        window.systemData &&
        window.systemData.modules &&
        window.systemData.modules.includes("notify")
      ) {
        _.chiamataAxios(
          "GET",
          "/auth/notify/getUserAutoNotifyRoles/" + _.masterId
        ).then((response) => {
          _.notifyData = response && response.data && response.data.length > 0;
        });
      }
    },
    onSelect: function (items) {
      this.selected = items;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
  },
  mounted() {
    if (this.paramsType) {
      this.masterId = this.paramsMasterId;
      this.type = this.paramsType;
      this.startTab = parseInt(this.$route.query.tab, 10) || 0;
      this.initProfileData();

      this.onResponsiveInverted();
      window.addEventListener("resize", this.onResponsiveInverted);
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  watch: {
    paramsMasterId: function (newVal, oldVal) {
      if (newVal) this.masterId = newVal;
    },
    tabs(value) {
      this.onTabChange(value);
    },
  },
};
</script>
<style lang="scss">
#profile-page {
  padding-left: 0px;
  padding-right: 0px;
}
.text-right {
  display: flex;
}
.mobileTabsMenu {
  width: 100%;
  margin-bottom: 12px;
}
.mobileTabsMenu .v-menu {
  display: block;
  width: 100%;
}
#profileData {
  padding-left: 5px;
  padding-right: 5px;
}
.tabs-container {
  margin-top: 20px;
}
</style>
